/* Nataliz infinite scroll for collection and search grids. Replaces the Scroll Bee app.
   When the shopper nears the bottom of the grid it loads the next page of the same section
   (Shopify section rendering) and appends the cards. Page numbers stay in the markup as the
   fallback and are only hidden once this script has started. */
(function () {
  'use strict';

  var HAS_IO = 'IntersectionObserver' in window && 'fetch' in window && 'URL' in window;
  var CACHE_PREFIX = 'nzinf:';
  var CACHE_LIMIT = 2400000;
  var box = null;
  var state = null;
  var io = null;
  var booted = false;

  function getList() {
    var g = document.getElementById('product-grid');
    if (!g) return null;
    return g.tagName === 'UL' ? g : g.querySelector('ul.grid, ul.product-grid');
  }

  function keyOf(li) {
    var a = li.querySelector('a[href*="/products/"], a[href*="/blogs/"], a[href*="/pages/"]');
    return a ? a.getAttribute('href').split('?')[0] : '';
  }

  function clean(li) {
    li.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
    li.removeAttribute('data-cascade');
    li.style.removeProperty('--animation-order');
  }

  function cacheKey() {
    return CACHE_PREFIX + location.pathname + location.search;
  }

  function readCache() {
    try {
      var raw = sessionStorage.getItem(cacheKey());
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeCache() {
    if (!state || !state.parts.length) return;
    try {
      var entry = {
        start: state.start,
        next: state.next,
        html: state.parts.join(''),
        y: Math.round(window.pageYOffset || 0)
      };
      var raw = JSON.stringify(entry);
      if (raw.length < CACHE_LIMIT) sessionStorage.setItem(cacheKey(), raw);
    } catch (e) {}
  }

  function dropCache() {
    try {
      sessionStorage.removeItem(cacheKey());
    } catch (e) {}
  }

  function logoSrc() {
    var el =
      document.querySelector('.header__heading-logo') ||
      document.querySelector('header .header__heading-link img') ||
      document.querySelector('header img');
    return el ? el.currentSrc || el.src : '';
  }

  function buildLoader(label, logo) {
    var o = document.createElement('div');
    o.className = 'nzld';
    var ring = document.createElement('div');
    ring.className = 'nzld-ring';
    var src = logo || logoSrc();
    if (src) {
      var im = document.createElement('img');
      im.className = 'nzld-logo';
      im.src = src;
      im.alt = '';
      ring.appendChild(im);
    }
    o.appendChild(ring);
    var t = document.createElement('div');
    t.className = 'nzld-txt';
    t.textContent = label || 'Loading';
    o.appendChild(t);
    return o;
  }

  function show(mode) {
    if (!box) return;
    var loader = box.querySelector('.nz-infinite__loader');
    var btn = box.querySelector('.nz-infinite__btn');
    var end = box.querySelector('.nz-infinite__end');
    var err = box.querySelector('.nz-infinite__err');
    box.setAttribute('data-state', mode);
    if (loader) loader.hidden = mode !== 'loading';
    if (btn) btn.hidden = !(mode === 'error' || (mode === 'idle' && !HAS_IO));
    if (end) end.hidden = mode !== 'end';
    if (err) err.hidden = mode !== 'error';
  }

  function pageUrl(n) {
    var u = new URL(location.href);
    u.searchParams.set('page', String(n));
    u.searchParams.set('section_id', state.section);
    return u.pathname + u.search;
  }

  function parseItems(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var g = doc.getElementById('product-grid');
    if (!g) return [];
    var ul = g.tagName === 'UL' ? g : g.querySelector('ul.grid, ul.product-grid');
    return ul ? [].slice.call(ul.children) : [];
  }

  function addItems(items) {
    var list = getList();
    if (!list) return 0;
    var frag = document.createDocumentFragment();
    var html = '';
    var added = 0;
    items.forEach(function (node) {
      if (!node || node.nodeType !== 1) return;
      var li = document.importNode(node, true);
      var key = keyOf(li);
      if (key && state.seen[key]) return;
      if (key) state.seen[key] = 1;
      clean(li);
      html += li.outerHTML;
      frag.appendChild(li);
      added++;
    });
    list.appendChild(frag);
    state.parts.push(html);
    return added;
  }

  function finish() {
    if (state.next > state.pages) {
      state.done = true;
      show('end');
      if (io) io.disconnect();
    } else {
      show('idle');
      if (io) {
        io.unobserve(box);
        io.observe(box);
      }
    }
  }

  function load() {
    if (!state || state.busy || state.done) return;
    var s = state;
    var n = s.next;
    s.busy = true;
    show('loading');
    fetch(pageUrl(n), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        if (state !== s) return;
        var items = parseItems(html);
        if (!items.length) throw new Error('empty page');
        addItems(items);
        s.next = n + 1;
        s.busy = false;
        writeCache();
        finish();
      })
      .catch(function () {
        if (state !== s) return;
        s.busy = false;
        show('error');
      });
  }

  function restore() {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var back = nav ? nav.type === 'back_forward' : false;
    if (!back) {
      dropCache();
      return;
    }
    var entry = readCache();
    if (!entry || entry.start !== state.start || !entry.html) return;
    var tpl = document.createElement('template');
    tpl.innerHTML = entry.html;
    var items = [].slice.call(tpl.content.children);
    if (!items.length) return;
    addItems(items);
    state.next = entry.next;
    try {
      history.scrollRestoration = 'manual';
    } catch (e) {}
    var y = entry.y || 0;
    window.scrollTo(0, y);
    setTimeout(function () {
      window.scrollTo(0, y);
    }, 250);
    window.addEventListener('load', function () {
      window.scrollTo(0, y);
    });
  }

  function teardown() {
    if (io) {
      io.disconnect();
      io = null;
    }
  }

  function init() {
    var el = document.getElementById('NzInfinite');
    if (el === box) return;
    teardown();
    box = el;
    state = null;
    if (!el) return;
    var grid = document.getElementById('product-grid');
    var list = getList();
    if (!grid || !list) return;
    var current = parseInt(el.getAttribute('data-current'), 10) || 1;
    var pages = parseInt(el.getAttribute('data-pages'), 10) || 1;
    state = {
      start: current,
      next: current + 1,
      pages: pages,
      section: grid.getAttribute('data-id'),
      busy: false,
      done: false,
      parts: [],
      seen: {}
    };
    [].forEach.call(list.children, function (li) {
      var k = keyOf(li);
      if (k) state.seen[k] = 1;
    });

    var loader = el.querySelector('.nz-infinite__loader');
    if (loader && !loader.firstChild) {
      loader.appendChild(buildLoader(loader.getAttribute('data-label'), loader.getAttribute('data-logo')));
    }
    var btn = el.querySelector('.nz-infinite__btn');
    if (btn) btn.addEventListener('click', load);

    document.documentElement.classList.add('nz-inf-on');
    var first = !booted;
    booted = true;
    if (first) restore();
    if (state.next > state.pages) {
      state.done = true;
      show('end');
      return;
    }
    show('idle');
    if (HAS_IO) {
      io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              load();
              break;
            }
          }
        },
        { rootMargin: '0px 0px 1100px 0px' }
      );
      io.observe(el);
    }
  }

  function start() {
    try {
      init();
      var wrap = document.getElementById('ProductGridContainer');
      if (wrap && window.MutationObserver) {
        new MutationObserver(function () {
          try {
            init();
          } catch (e) {}
        }).observe(wrap, { childList: true });
      }
      window.addEventListener('pagehide', function () {
        writeCache();
      });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
